module.exports = __webpack_public_path__ + "img/expand-orange.20b3f5bc.svg";